import { Box, FormControl, FormGroup, InputLabel, MenuItem, Select, Stack, TextField, Typography } from "@mui/material";
import { useMemo } from "react";
import { RewardCalculationType } from "../../../../types/actionModule/rewardCalculationType/rewardCalculationType";
import { RewardType } from "../../../../types/actionModule/rewardType";
import { rewardCalculationTypes } from "../../../../types/actionModule/actionModuleTypes";
import { RewardCalculationState } from "../../../../types/actionModule/editor/actionModuleEditorTypes";
import { useTranslation } from "react-i18next";

interface Props {
    value: RewardCalculationState;
    onChange: (value: RewardCalculationState) => void;
}

export default function RewardCalculationEditor(props: Props) {
    const { t } = useTranslation();
    const rewardCalculationType = useMemo(() =>
        rewardCalculationTypes.find((i) => i.type === props.value.selectedRewardCalculationType),
        [props.value.selectedRewardCalculationType],
    );

    const onChangeRewardCalculationType = (newType: RewardCalculationType) => {
        const rewardCalculationType = rewardCalculationTypes.find(
            (i) => i.type === newType,
        );

        props.onChange({
            ...props.value,
            selectedRewardCalculationType: newType,
            rewardCalculationType: {
                ...rewardCalculationType?.defaultValue ?? {},
                type: newType,
            }
        });
    };


    return <Box sx={{p: 2}}>
        <Typography variant="subtitle2">{t("actionModuleEditor.tabRewardCalculation.common")}</Typography>
        <FormGroup sx={{ gap: 2, pb: 2, pt: 1 }}>
            <Stack direction="row" sx={{gap: 2}}>
                <FormControl sx={{ minWidth: 250, flex: 1 }} >
                    <InputLabel>{t("actionModuleEditor.tabRewardCalculation.rewardType")}</InputLabel>
                    <Select
                        label={t("actionModuleEditor.tabRewardCalculation.rewardType")}
                        value={props.value.rewardType}
                        size="small"
                        fullWidth
                        onChange={(v) => props.onChange({
                            ...props.value,
                            rewardType: v.target.value as RewardType
                        })}
                    >
                        <MenuItem value={RewardType.Nothing}>{t("actionModuleEditor.tabRewardCalculation.rewardTypeNothing")}</MenuItem>
                        <MenuItem value={RewardType.Flames}>{t("actionModuleEditor.tabRewardCalculation.rewardTypeFlames")}</MenuItem>
                        <MenuItem value={RewardType.Points}>{t("actionModuleEditor.tabRewardCalculation.rewardTypePoints")}</MenuItem>
                    </Select>
                </FormControl>
                <FormGroup sx={{ flex: 1 }}>
                    <TextField
                        value={props.value.maxReward}
                        onChange={(e) => props.onChange({
                            ...props.value,
                            maxReward: Number(e.target.value)
                        })}
                        size="small"
                        fullWidth
                        label={t("actionModuleEditor.tabRewardCalculation.maxReward")} />
                </FormGroup>
            </Stack>
        </FormGroup>

        <Typography variant="subtitle2" sx={{pb: 1}}>{t("actionModuleEditor.tabRewardCalculation.rewardCalculationType")}</Typography>
        <FormControl sx={{ minWidth: 250, flex: 1, pb: 2 }}>
            <InputLabel>{t("actionModuleEditor.tabRewardCalculation.rewardCalculationType")}</InputLabel>
            <Select
                value={props.value.selectedRewardCalculationType}
                label={t("actionModuleEditor.tabRewardCalculation.rewardCalculationType")}
                size="small"
                onChange={(v) => onChangeRewardCalculationType(v.target.value as RewardCalculationType)}
            >
                {
                    rewardCalculationTypes.map((s) =>
                        <MenuItem key={s.type} value={s.type}>{t(s.name)}</MenuItem>
                    )
                }
            </Select>
        </FormControl>
        {
            rewardCalculationType && props.value.rewardType !== RewardType.Nothing && <>
                {rewardCalculationType.editor({
                    value: props.value.rewardCalculationType,
                    onChanged: (value) => props.onChange({
                        ...props.value,
                        rewardCalculationType: value,
                    })
                })}
            </>
        }
    </Box>
}